import React from 'react';

/**
 * Lightweight tab navigation (replaces PrimeReact TabView on settings pages).
 * tabs: [{ label: string, content: ReactNode }]
 */
export default function SettingsTabNav({tabs, activeIndex = 0, onTabChange, className = ''}) {
    const shellClass = ['settings-page__tab-shell', className].filter(Boolean).join(' ');
    const safeIndex = activeIndex >= 0 && activeIndex < tabs.length ? activeIndex : 0;
    const activeTab = tabs[safeIndex];

    return (
        <div className={shellClass}>
            <nav className="settings-page__tab-nav" role="tablist" aria-label="Settings sections">
                {tabs.map((tab, index) => {
                    const isActive = index === safeIndex;
                    const itemClass = [
                        'settings-page__tab-nav-item',
                        isActive ? 'settings-page__tab-nav-item--active' : ''
                    ].filter(Boolean).join(' ');
                    return (
                        <button
                            key={tab.id || tab.label || index}
                            type="button"
                            role="tab"
                            aria-selected={isActive}
                            className={itemClass}
                            onClick={() => onTabChange && onTabChange(index)}>
                            {tab.label}
                        </button>
                    );
                })}
            </nav>
            <div className="settings-page__tab-panel" role="tabpanel">
                {activeTab && activeTab.content}
            </div>
        </div>
    );
}
